import React from 'react';
import { get } from 'lodash';

// React view component to render
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { memberInfoSettings as MemberInfoSettingsView } from 'ui/views/widgets/memberInfoSettings';
import { MemberInfoSettingsService } from 'services/memberInfoSettings';
import { withRouter } from 'react-router-dom';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { MemberInfoSettings } from 'ui/containers/MemberInfoSettings';
 *
 * // render
 * <MemberInfoSettings propName='propValue'/>
 */
class _MemberInfoSettings extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );
        this.fetchGeneration = 0;
        this.fetchActive = true;

        // component state
        this.state = {
            isFetching: true,
            networkStatus: undefined,
            componentData: undefined,
        };

        // Member Info Settings Service
        this.memberInfoSettingsService = new MemberInfoSettingsService();

        // Member Info Settings data fetch
        this.fetchComponentData();
    }

    /**************************************************** */

    /**
     * @desc Fetch member Info Settings.
     */
    async fetchComponentData() {
       
        log.debug( 'MemberInfoSettings.fetchComponentData()' );

        const generation = ++this.fetchGeneration;
        // cancel ongoing request
        this.memberInfoSettingsService.cancel();

        try {
            const { status, data }  = await this.memberInfoSettingsService.fetchData( {
                url: this.props.widget.url,
                requestPayload: this.props.requestPayload,
            } );

            if( ! this.fetchActive || generation !== this.fetchGeneration ) return;

            // check if response status was success
            if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
                this.setState( () => this.fetchActive && generation === this.fetchGeneration ? ( {
                    isFetching: false,
                    networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
                } ) : null );
            } else {
                this.setState( () => this.fetchActive && generation === this.fetchGeneration ? ( {
                    isFetching: false,
                    networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                    componentData: data,
                } ) : null );
            }

        } catch( e ) {
            if( ! this.fetchActive || generation !== this.fetchGeneration ) return;
            this.setState( () => this.fetchActive && generation === this.fetchGeneration ? ( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE,
            } ) : null );
        }
    }

    /*********************************************/

    /**
     * @desc When component unmounts, cleanup resources.
     */
    componentWillUnmount() {
        this.fetchActive = false;
        this.fetchGeneration++;
        this.memberInfoSettingsService.cancel(); // cancel ongoing requests
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <MemberInfoSettingsView
                isFetching={ this.state.isFetching }
                networkStatus={ this.state.networkStatus }
                { ...get( this.state, 'componentData', {} ) }
                requestPayload={ this.props.requestPayload }
                location={ this.props.location }
            />
        );
    }
}

// set display name
_MemberInfoSettings.displayName = '_MemberInfoSettings';

// set default props
_MemberInfoSettings.defaultProps = {};

// prop types
_MemberInfoSettings.propTypes = {};

/*********************************************/

// wrap with router
export const MemberInfoSettings = withRouter( _MemberInfoSettings );

